import React, { useMemo } from 'react';
import FilterBar from '../../components/FilterBar/FilterBar';
import { FilterWrapper } from './UserPortalFilterBarContainer.style';

const STATUS = ['AWAITING VENDOR CONFIRMATION', 'VENDOR VALIDATION REQUESTED', 'VENDOR CONFIRMED', 'AWAITING PAYMENT', 'PAID', 'VENDOR ORDER PROCESSED', 'ASSEMBLING ORDER', 'SHIPPED', 'DELIVERED', 'CANCELLED'];
const PRIORITY = ['STANDARD', 'HIGH', 'URGENT'];
const PAYMENT_STATUS = ['Awaiting Payment', 'Paid', 'Failed', '—'];

/**
 * Props:
 *   onChange?: (filters: { search?: string, status?: string, priority?: string, payment_status?: string }) => void
 *   value?:    { search?: string, status?: string, priority?: string, payment_status?: string }
 */
export default function UserPortalFilterBar({ onChange, value = {} }) {
  const dropdowns = useMemo(() => ([
    {
      key: 'status',
      options: [
        { value: '', label: 'Select Status' },
        ...STATUS.map(s => ({ value: s, label: s })),
      ],
    },
    {
      key: 'priority',
      options: [
        { value: '', label: 'Select Priority' },
        ...PRIORITY.map(p => ({ value: p, label: p })),
      ],
    },
    {
      key: 'payment_status',
      options: [
        { value: '', label: 'Select Payment Status' },
        ...PAYMENT_STATUS.map(p => ({ value: p, label: p })),
      ],
    },
  ]), []);

  const handleFilterChange = (values) => {
    onChange?.({
      search: values.search ?? value.search ?? '',
      status: values.status ?? value.status ?? '',
      priority: values.priority ?? value.priority ?? '',
      payment_status: values.payment_status ?? value.payment_status ?? '',
    });
  };

  return (
    <FilterWrapper>
      <FilterBar
        dropdowns={dropdowns}
        onChange={handleFilterChange}
        showNewButton={false}
        placeholder="Name, email, etc..."
        value={{
          search: value.search ?? '',
          status: value.status ?? '',
          priority: value.priority ?? '',
          payment_status: value.payment_status ?? '',
        }}
      />
    </FilterWrapper>
  );
}
